import { Modal } from 'react-bootstrap-v5'
import { useState, useCallback, useEffect } from 'react';
import { IArquivoEmpresa } from '../../interfaces/IArquivoEmpresa';
import { uniqueId } from 'lodash';
import Swal from 'sweetalert2';
import ArquivoEmpresaService from '../../services/ArquivoEmpresaService';
import ReactS3Client from 'react-aws-s3-typescript';
import { configBucket } from '../../utils/S3Utils';
/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
const ModalProcessarArquivos = ({ show, toggleModal, esteiraID, empresaID }: { show: boolean, toggleModal: Function, esteiraID: number, empresaID: number }) => {
    const { t } = useTranslation();
    const [tipo] = useState<any>({
        1: 'Posição Financeira',
        3: 'Posição Financeira por nota',
        4: 'Posição Financeira por linha',
        5: 'Posição Financeira Duplicatas Descontadas',
        6: 'Folha de pagamento',
        7: 'Pagamento da folha',
        8: 'Posição de tributos',
        9: 'Posição de imobilizados',
        10: 'Posição ISS',
        11: 'Posição de tributos retidos',
        12: 'Posição Financeira Cte',
        13: 'Resumo da folha'
    });
    const [arquivos, setArquivos] = useState<IArquivoEmpresa[]>([]);
    const [tipoArquivo, setTipoArquivo] = useState<number>(0);
    const [loadingFile, setLoadingFile] = useState<boolean>(false);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [linhaInicial, setLinhaInicial] = useState<string>('1');
    const [customModal, setCustomModal] = useState<number>(0);
    const [idSelecionado, setIdSelecionado] = useState<number>(0);
    const [razaoSocial, setRazaoSocial] = useState<string>('');
    const [documento, setDocumento] = useState<string>('');
    const [dataEmissao, setDataEmissao] = useState<string>('');
    const [dataPagamento, setDataPagamento] = useState<string>('');
    const [valorEmissao, setValorEmissao] = useState<string>('');
    const [valorPagamento, setValorPagamento] = useState<string>('');
    const [conta, setConta] = useState<string>('');
    const [valorSaldo, setValorSaldo] = useState<string>('');
    const [esteiraImportada, setEsteiraImportada] = useState<number>(esteiraID);


    const onChangeFile = useCallback(async (e: any) => {
        if (tipoArquivo === 0) {
            Swal.fire({
                text: 'Por favor selecione um tipo de arquivo a ser anexado!',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
        } else {
            if (e.target.files !== null && e.target.files.length > 0) {
                setLoadingFile(true);
                const file = e.target.files[0] as File;

                const s3 = new ReactS3Client(configBucket);
                const res = await s3.uploadFile(file, file.name);
                const item = { esteiraID, empresaID: empresaID, nome: file.name, url: res.location, id: 0, tipo: tipo[tipoArquivo] } as IArquivoEmpresa;
                ArquivoEmpresaService.cadastrarArquivo(item).then((result) => {
                    Swal.fire({
                        text: 'Arquivo importado com sucesso!',
                        timer: 3000,
                        icon: 'success',
                        showConfirmButton: false
                    });

                    setArquivos((old) => {
                        const copy = [...old];
                        copy.push({ ...item, id: result.id, });
                        return copy;
                    });

                    setLoadingFile(false);
                });
            }
        }
    }, [tipoArquivo, empresaID, tipo, esteiraID]);

    const processarArquivo = useCallback((tipoArquivo: number) => {
        Swal.fire({
            title: 'Qual o tipo ?',
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'ATIVO',
            denyButtonText: `PASSIVO`,
        }).then((result) => {

            const tipoEncontrado = tipo[tipoArquivo];

            if (result.isConfirmed) {
                setLoadingFile(true);


                if (tipoEncontrado === tipo[1]) {
                    ArquivoEmpresaService.processarPosicao(idSelecionado, esteiraID, true, {
                        linha: linhaInicial,
                        documento,
                        razaoSocial,
                        valorEmissao,
                        valorPagamento,
                        conta,
                        dataEmissao,
                        dataPagamento,
                        valorSaldo
                    }).then(() => {
                        Swal.fire({
                            text: 'Arquivo inserido na fila de processamento, após você receberá um e-mail com o resultado da confirmação!',
                            timer: 3000,
                            icon: 'success',
                            showConfirmButton: false
                        });
                        setLoadingFile(false);
                    });
                } else {
                    ArquivoEmpresaService.processar(idSelecionado, esteiraID, "A", tipo[tipoArquivo], {
                        linha: linhaInicial,
                        documento,
                        razaoSocial,
                        valorEmissao,
                        valorPagamento,
                        conta,
                        dataEmissao,
                        dataPagamento,
                        valorSaldo
                    }).then(() => {
                        Swal.fire({
                            text: 'Arquivo inserido na fila de processamento, após você receberá um e-mail com o resultado da confirmação!',
                            timer: 3000,
                            icon: 'success',
                            showConfirmButton: false
                        });
                        setLoadingFile(false);
                    });
                }
            } else if (result.isDenied) {
                setLoadingFile(true);

                if (tipoEncontrado === tipo[1]) {
                    ArquivoEmpresaService.processarPosicao(idSelecionado, esteiraID, false, {
                        linha: linhaInicial,
                        documento,
                        razaoSocial,
                        valorEmissao,
                        valorPagamento,
                        conta,
                        dataEmissao,
                        dataPagamento,
                        valorSaldo
                    }).then(() => {
                        Swal.fire({
                            text: 'Arquivo inserido na fila de processamento, após você receberá um e-mail com o resultado da confirmação!',
                            timer: 3000,
                            icon: 'success',
                            showConfirmButton: false
                        });
                        setLoadingFile(false);
                    });
                } else {
                    ArquivoEmpresaService.processar(idSelecionado, esteiraID, "P", tipo[tipoArquivo], {
                        linha: linhaInicial,
                        documento,
                        razaoSocial,
                        valorEmissao,
                        valorPagamento,
                        conta,
                        dataEmissao,
                        dataPagamento,
                        valorSaldo
                    }).then(() => {
                        Swal.fire({
                            text: 'Arquivo inserido na fila de processamento, após você receberá um e-mail com o resultado da confirmação!',
                            timer: 3000,
                            icon: 'success',
                            showConfirmButton: false
                        });
                        setLoadingFile(false);
                    });
                }
            }
        });
    }, [esteiraID, dataPagamento, dataEmissao, valorPagamento, valorEmissao, razaoSocial, documento, linhaInicial, valorSaldo, idSelecionado, conta]);

    const processarContasPagamentoFolha = useCallback((id: number) => {
        ArquivoEmpresaService.processarNovoPagamentoFolha(esteiraID);
        Swal.fire({
            text: 'As contas de folha serão movidas para processamento, caso isso não aconteça por favor recarregue sua página.',
            timer: 3000,
            icon: 'success',
            showConfirmButton: false
        });
        setLoadingFile(false);

        setArquivos((old) => {
            const cp = [...old];
            cp.forEach(f => {
                if (f.tipo === 'Pagamento da folha') {
                    f.processando = true;
                }
            });
            return cp;
        })
    }, [esteiraID]);

    const processarPosicaoTributos = useCallback((id: number) => {
        ArquivoEmpresaService.processarPosicaoTributo(esteiraID, id);
        Swal.fire({
            text: 'A posição de tributo foi enviada para processamento, por favor aguarde as notificações e o resultado no e-mail.',
            timer: 3000,
            icon: 'success',
            showConfirmButton: false
        });
        setLoadingFile(false);

        setArquivos((old) => {
            const cp = [...old];
            cp.forEach(f => {
                if (f.tipo === 'Posição de tributos') {
                    f.processando = true;
                }
            });
            return cp;
        })
    }, [esteiraID]);

    const processarPosicaoTributosRetidos = useCallback((id: number) => {
        ArquivoEmpresaService.processarPosicaoTributoRetido(esteiraID, id);
        Swal.fire({
            text: 'A posição de tributo retido foi enviada para processamento, por favor aguarde as notificações e o resultado no e-mail.',
            timer: 3000,
            icon: 'success',
            showConfirmButton: false
        });
        setLoadingFile(false);

        setArquivos((old) => {
            const cp = [...old];
            cp.forEach(f => {
                if (f.tipo === 'Posição de tributos retidos') {
                    f.processando = true;
                }
            });
            return cp;
        })
    }, [esteiraID]);

    const processarPosicaoISS = useCallback((id: number) => {
        ArquivoEmpresaService.processarPosicaoISS(esteiraID, id);
        Swal.fire({
            text: 'A posição ISS foi enviada para processamento, por favor aguarde as notificações e o resultado no e-mail.',
            timer: 3000,
            icon: 'success',
            showConfirmButton: false
        });
        setLoadingFile(false);

        setArquivos((old) => {
            const cp = [...old];
            cp.forEach(f => {
                if (f.tipo === 'Posição ISS') {
                    f.processando = true;
                }
            });
            return cp;
        })
    }, [esteiraID]);


    const processarPosicaoImobilizados = useCallback((id: number) => {
        ArquivoEmpresaService.processarPosicaoImobilizado(esteiraID, id);
        Swal.fire({
            text: 'A posição de imobilizados foi enviada para processamento, por favor aguarde as notificações e o resultado no e-mail.',
            timer: 3000,
            icon: 'success',
            showConfirmButton: false
        });
        setLoadingFile(false);

        setArquivos((old) => {
            const cp = [...old];
            cp.forEach(f => {
                if (f.tipo === 'Posição de imobilizados') {
                    f.processando = true;
                }
            });
            return cp;
        })
    }, [esteiraID]);

    const processarContasFolha = useCallback((id: number) => {
        ArquivoEmpresaService.processarNovo(esteiraID);
        Swal.fire({
            text: 'As contas de folha serão movidas para processamento, caso isso não aconteça por favor recarregue sua página.',
            timer: 3000,
            icon: 'success',
            showConfirmButton: false
        });
        setLoadingFile(false);

        setArquivos((old) => {
            const cp = [...old];
            cp.forEach(f => {
                if (f.tipo === 'Folha de pagamento') {
                    f.processando = true;
                }
            });
            return cp;
        })
    }, [esteiraID]);

    useEffect(() => {
        if (esteiraID !== esteiraImportada) {
            setEsteiraImportada(esteiraID);
            setLoaded(false);
        }
    }, [esteiraID, esteiraImportada]);

    useEffect(() => {
        if ((empresaID === 0 || empresaID) && !loaded && esteiraID) {
            ArquivoEmpresaService.buscarTodos(empresaID, esteiraID).then((resp) => {
                setArquivos(resp);
                setLoaded(true);
            }).catch(() => {
                Swal.fire({
                    text: 'Ocorreu um erro ao buscar os arquivos anexados a empresa!',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });
            });
        }
    }, [empresaID, loaded, esteiraID]);

    return (
        <>
            <Modal size='lg' centered={true} show={customModal > 0} onHide={() => setCustomModal(0)}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <h5 className="modal-title titulo-modal">Colunas Posição Financeira</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={() => setCustomModal(0)} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-md-4 form-group'>
                                <label>Linha inicial</label>
                                <input className='form-control' value={linhaInicial} onChange={(e) => setLinhaInicial(e.target.value)} type='number' />
                            </div>
                            <div className='col-md-4 form-group'>
                                <label>Coluna Razão Social (A)</label>
                                <input className='form-control' value={razaoSocial} onChange={(e) => setRazaoSocial(e.target.value)} type='text' />
                            </div>
                            <div className='col-md-4 form-group'>
                                <label>{customModal === 12 ? 'Número Título' : 'Coluna Documento'} (B)</label>
                                <input className='form-control' value={documento} onChange={(e) => setDocumento(e.target.value)} type='text' />
                            </div>
                            {(customModal === 1 || customModal === 4 || customModal === 5 || customModal === 12) && (
                                <>
                                    <div className='col-md-4 form-group'>
                                        <label>Coluna Data Emissão (C)</label>
                                        <input className='form-control' value={dataEmissao} onChange={(e) => setDataEmissao(e.target.value)} type='text' />
                                    </div>
                                    <div className='col-md-4 form-group'>
                                        <label>Coluna Data Pagamento (D)</label>
                                        <input className='form-control' value={dataPagamento} onChange={(e) => setDataPagamento(e.target.value)} type='text' />
                                    </div>
                                    <div className='col-md-4 form-group'>
                                        <label>Coluna Valor Emissão (E)</label>
                                        <input className='form-control' value={valorEmissao} onChange={(e) => setValorEmissao(e.target.value)} type='text' />
                                    </div>
                                    <div className='col-md-4 form-group'>
                                        <label>Coluna Valor Pagamento (F)</label>
                                        <input className='form-control' value={valorPagamento} onChange={(e) => setValorPagamento(e.target.value)} type='text' />
                                    </div>
                                    <div className='col-md-4 form-group'>
                                        <label>Conta (Referência)</label>
                                        <input className='form-control' value={conta} onChange={(e) => setConta(e.target.value)} type='text' />
                                    </div>
                                </>
                            )}
                            {customModal === 3 && (
                                <div className='col-md-4 form-group'>
                                    <label>Coluna Saldo</label>
                                    <input className='form-control' value={valorSaldo} onChange={(e) => setValorSaldo(e.target.value)} type='text' />
                                </div>
                            )}
                            <div className='col-md-4 mt-5'>
                                <button type='button' className="btn btn-success" onClick={() => processarArquivo(customModal)}>Confirmar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Processar Arquivos</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <button onClick={() => toggleModal()} style={{ backgroundColor: 'none', border: 'none' }}>
                                <i className="fas fa-times" style={{ color: '#5E6397' }}></i>
                            </button>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12">
                                {!arquivos && <label>{t("Nenhum anexo foi encontrado")}</label>}
                                {arquivos.filter(f => f.tipo !== "Saldo Inicial").map((item) => (
                                    <div key={uniqueId()} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }} className='mt-4'>
                                        <i className='fa fa-paperclip fs-4' />
                                        <p style={{ margin: 0, marginLeft: '10px' }}>{item.nome} - {item.tipo}</p>
                                        {item.tipo !== "Saldo Inicial" && item.tipo !== "Folha de pagamento" && item.tipo !== "Pagamento da folha" && item.tipo !== "Resumo da folha" && item.tipo !== "Posição de tributos" && item.tipo !== "Posição de imobilizados" && item.tipo !== "Posição ISS" && item.tipo !== "Posição de tributos retidos" && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => {
                                            setIdSelecionado(item.id);
                                            setCustomModal(parseInt(Object.keys(tipo).find((item2) => tipo[item2] === item.tipo || "") || "0"));
                                        }} disabled={loadingFile}>Processar</button>}
                                        {item.tipo === "Folha de pagamento" && !item.processado && !item.processando && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => processarContasFolha(item.id)} disabled={loadingFile}>Processar</button>}
                                        {item.tipo === "Resumo da folha" && !item.processado && !item.processando && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => processarContasFolha(item.id)} disabled={loadingFile}>Processar</button>}
                                        {item.tipo === "Pagamento da folha" && !item.processado && !item.processando && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => processarContasPagamentoFolha(item.id)} disabled={loadingFile}>Processar</button>}
                                        {item.tipo === "Posição de tributos" && !item.processado && !item.processando && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => processarPosicaoTributos(item.id)} disabled={loadingFile}>Processar</button>}
                                        {item.tipo === "Posição de tributos retidos" && !item.processado && !item.processando && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => processarPosicaoTributosRetidos(item.id)} disabled={loadingFile}>Processar</button>}
                                        {item.tipo === "Posição de imobilizados" && !item.processado && !item.processando && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => processarPosicaoImobilizados(item.id)} disabled={loadingFile}>Processar</button>}
                                        {item.tipo === "Posição ISS" && !item.processado && !item.processando && <button style={{ marginLeft: '5px' }} type="button" className="btn btn-danger" onClick={() => processarPosicaoISS(item.id)} disabled={loadingFile}>Processar</button>}
                                        {item.processando && <label style={{ marginLeft: '8px', fontWeight: 'bold' }}> - Processando</label>}
                                    </div>
                                ))}
                            </div>
                            <div className="col-md-12 mt-6">
                                <div className="form-group">
                                    <label>Selecione um tipo de arquivo a ser importado...</label>
                                    <select className="form-control" value={tipoArquivo} onChange={(e) => setTipoArquivo(parseInt(e.target.value))}>
                                        <option value={0}>Selecione um tipo...</option>
                                        <option value={1}>Posição Financeira</option>
                                        <option value={3}>Posição Financeira por nota</option>
                                        <option value={4}>Posição Financeira (Provisão/Baixa) por Linha</option>
                                        <option value={5}>Posição Financeira Duplicatas Descontadas</option>
                                        <option value={6}>Importação da folha de pagamento com vários líquidos</option>
                                        <option value={7}>Importação de pagamento da folha</option>
                                        <option value={8}>Posição de tributos</option>
                                        <option value={9}>Posição de imobilizados</option>
                                        <option value={10}>Posição ISS</option>
                                        <option value={11}>Posição de tributos retidos</option>
                                        <option value={12}>Posição Financeira Cte</option>
                                        <option value={13}>Resumo da folha</option>
                                    </select>
                                </div>
                            </div>
                            {tipoArquivo === 1 || tipoArquivo === 3 && (
                                <div className="col-md-12 mt-2">
                                    <label><b>Ao importar um arquivo de posição financeira, você receberá um e-mail com o resultado do processamento.</b></label>
                                </div>
                            )}
                            <div className="col-md-12 mt-2">
                                <label>Selecione um arquivo para importar</label>
                                {loadingFile ? <p>Carregando...</p> : (
                                    <div className="form-group mt-2">
                                        <input type='file' placeholder='Anexar...' accept='*' onChange={(e) => onChangeFile(e)} className="form-control" />
                                    </div>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ModalProcessarArquivos